import React from 'react';
import { useState, useEffect, useContext, useRef } from 'react';
import { Container, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import MySnackbar from './MySnackbar';
import AppContext from '../AppContext'; 

const DataLoader = ({ id, fetchFunction, goBackLocation, children}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState({ message: "", open: false });
  const [loading, setLoading] = useState(true);  
  const { ctxUser, setCtxUser } = useContext(AppContext);
  const jwtToken = ctxUser?.fdvToken ? ctxUser.fdvToken.jwtToken : '';

  const navigate = useNavigate();
  const hasNavigated = useRef(false); // Ref para controlar el navigate

  const handleClose = () => {
    setError((prevError) => ({ ...prevError, open: false }));
  };

  const onError = (err, titol) => {
    const msg = err.response?.data?.message || "Error al " + titol;
    const unAuthorized = err.response?.status === 401 || err.status === 401;
    setError({ 
      message: msg, 
      open: true, 
      unAuthorized
    });
  };
  
  useEffect(() => {
    // Si no hay token, no hacemos el fetch pero nos quedamos cargando (esperando a AuthHandler)
    if (!jwtToken) {
      setLoading(true);
      return;
    }

    hasNavigated.current = false;
    setLoading(true);

    fetchFunction(jwtToken, 
      (response) => setData(response.data || []), 
      onError,
      () => setLoading(false));
      // eslint-disable-next-line
  }, [jwtToken, id]);

   // Redirecciona después de 5 segundos si hay un error
   
   useEffect(() => {
    if (error.open && !hasNavigated.current) {
      hasNavigated.current = true;

      if(error.unAuthorized) {
        setCtxUser(prev => ({
          ...prev,
          isAuthenticated: false,
          fdvToken: { ...prev?.fdvToken, jwtToken: '' },
          error: { response: { status: 401, data: { message: error.message } } }
        }));
        return;
      }

      const timer = setTimeout(() => {
        setError((prevError) => ({ ...prevError, open: false }));
        
        if(goBackLocation){
          //console.log('Intenta redirigir a:', goBackLocation);
          navigate(goBackLocation, { replace: false });
        }       
      }, 5000);
      return () => clearTimeout(timer); // Limpia el temporizador al desmontar
    }
  // eslint-disable-next-line
  }, [error.open, error.unAuthorized, goBackLocation, data, loading]);


  // Renderiza los hijos (contenido de la página) cuando `data` está disponible
  return (
    <Container>
        <MySnackbar open={error.open} message={error.message} handleClose={handleClose}  />
        { loading && (      
          <Grid container justifyContent="center" alignItems="center" style={{ minHeight: '100vh' }}>
            <CircularProgress size={60} />
          </Grid>
        )}
        { data && children(data, onError) }
    </Container>);
};

export default DataLoader;
